const LockBlue = () => {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_ddd_34560_205559)">
        <rect x="12" y="1" width="36" height="36" rx="8" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30 9C27.2386 9 25 11.2386 25 14V16C23.3431 16 22 17.3431 22 19V26C22 27.6569 23.3431 29 25 29H35C36.6569 29 38 27.6569 38 26V19C38 17.3431 36.6569 16 35 16V14C35 11.2386 32.7614 9 30 9ZM33 16V14C33 12.3431 31.6569 11 30 11C28.3431 11 27 12.3431 27 14V16H33ZM30 20C30.5523 20 31 20.4477 31 21V24C31 24.5523 30.5523 25 30 25C29.4477 25 29 24.5523 29 24V21C29 20.4477 29.4477 20 30 20Z"
          fill="#225AEA"
        />
        <rect x="31" y="20" width="12" height="12" rx="6" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.8675 23.357C36.3892 22.5177 37.6106 22.5177 38.1323 23.357L40.1665 26.6295C40.7186 27.5176 40.0799 28.6667 39.0341 28.6667H34.9656C33.9199 28.6667 33.2812 27.5176 33.8333 26.6295L35.8675 23.357ZM37 24.6667C37.1841 24.6667 37.3333 24.8159 37.3333 25V26C37.3333 26.1841 37.1841 26.3333 37 26.3333C36.8159 26.3333 36.6666 26.1841 36.6666 26V25C36.6666 24.8159 36.8159 24.6667 37 24.6667ZM36.5833 27C36.5833 26.7699 36.7699 26.5833 37 26.5833C37.2301 26.5833 37.4166 26.7699 37.4166 27C37.4166 27.2301 37.2301 27.4167 37 27.4167C36.7699 27.4167 36.5833 27.2301 36.5833 27Z"
          fill="#A1A1AA"
        />
      </g>
      <defs>
        <filter
          id="filter0_ddd_34560_205559"
          x="0"
          y="0"
          width="60"
          height="60"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="12"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_34560_205559"
          />
          <feOffset dy="24" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_34560_205559"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="3"
            operator="erode"
            in="SourceAlpha"
            result="effect2_dropShadow_34560_205559"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_34560_205559"
            result="effect2_dropShadow_34560_205559"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="effect3_dropShadow_34560_205559"
          />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_34560_205559"
            result="effect3_dropShadow_34560_205559"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect3_dropShadow_34560_205559"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default LockBlue
